import { useEffect, useState } from "react";
import PageContainer from "../components/admin/PageContainer";
import CollapseCard from "../components/admin/CollapseCard";
import Modal from "../components/admin/Modal";
import { useToast } from "../components/toast/ToastProvider";
import { createCategory, deleteCategory, fetchAllCategory, updateCategory } from "../service/Category";
import CategoryForm from "../components/admin/CategoryForm";
import CategoryList from "../components/admin/CategoryList";
import Main from "../components/admin/Main";

const Category = () => {
  const [category, setCategory] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [viewMode, setViewMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const loadCategory = async () => {
    try {
      setLoading(true);
      const res = await fetchAllCategory();

      setCategory(res);
    } catch (error) {
      toast("Error in fetch Category", "ERROR");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadCategory();
  }, []);



  const handleSave = async (adData) => {
    try {
      const formData = new FormData();
      formData.append("name", adData.name);
      formData.append("imageUrl", adData.imageUrl);
     

      if (selectedCategory) {
        await updateCategory(selectedCategory.id, formData);
        toast("Category updated", "SUCCESS");
      } else {
        await createCategory(formData);
        toast("Category Added", "SUCCESS");
      }

      setShowModal(false);
      setSelectedCategory(null);
      setViewMode(false);
      await loadCategory();
    } catch (error) {
      toast("Error in save Category", "ERROR");
    }
  };
  const handleEdit = (ad) => {
    setSelectedCategory(ad);
    setViewMode(false);
    setShowModal(true);
  };

  const handleView = (ad) => {
    setSelectedCategory(ad);
    setViewMode(true);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this ad?")) {
      await deleteCategory(id);
      toast("Category deleted", "SUCCESS");
      await loadCategory();
    } else {
      toast("Error in delete Category", "ERROR");
    }
  };

  return (
    <Main>
      <PageContainer
        title="Category"
        buttonText={loading ? "Loading..." : "ADD"}
        onButtonClick={() => {
          setSelectedCategory(null);
          setViewMode(false);
          setShowModal(true);
        }}
      >
        <Modal
          visible={showModal}
          size="lg"
          onClose={() => {
            setShowModal(false);
            setSelectedCategory(null);
            setViewMode(false);
          }}
          headerText={
            viewMode
              ? "View Category"
              : selectedCategory
              ? "Edit Category"
              : "Add Category"
          }
          centered
        >
          <CategoryForm
            initialData={selectedCategory}
            readOnly={viewMode}
            onSave={handleSave}
          />

          {viewMode && (
            <div className="d-flex justify-content-end mt-3">
              <button
                className="btn btn-success"
                onClick={() => setViewMode(false)}
              >
                Edit
              </button>
            </div>
          )}
        </Modal>

        <CollapseCard title="Category List">
          <CategoryList
            category={category}
            onEdit={handleEdit}
            onDelete={handleDelete}
            onView={handleView}
          />
        </CollapseCard>
      </PageContainer>
    </Main>
  );
};

export default Category;
